import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import './auth.css';

function Signup() {
  const navigate = useNavigate();
  const [businessName, setBusinessName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    if (!businessName.trim()) {
      setError('Please enter your business name.');
      return;
    }

    setLoading(true);

    // Create Supabase auth account
    const { data, error: signUpError } = await supabase.auth.signUp({
      email,
      password,
    });

    if (signUpError) {
      setError(signUpError.message || 'Unable to create account. Please try again.');
      setLoading(false);
      return;
    }

    // Create basic business record
    if (data?.user) {
      await supabase.from('businesses').insert({
        business_name: businessName.trim(),
        owner_email: email,
        is_active: false,
      });
    }

    setLoading(false);
    navigate('/onboarding');
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Create your account</h1>
        <p className="auth-subtitle">Start your 30-day free trial — no credit card needed</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label">
            Business name
            <input
              type="text"
              className="auth-input"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              placeholder="e.g. Mike's Auto Shop"
              required
            />
          </label>
          <label className="auth-label">
            Email
            <input
              type="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@yourbusiness.com"
              required
            />
          </label>
          <label className="auth-label">
            Password
            <input
              type="password"
              className="auth-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
            />
          </label>
          <label className="auth-label">
            Confirm password
            <input
              type="password"
              className="auth-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
            />
          </label>
          {error && <div className="auth-message auth-message-error">{error}</div>}
          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Creating account…' : 'Create account & get started →'}
          </button>
        </form>
        <p style={{ textAlign: 'center', fontSize: '13px', color: '#5A6B84', marginTop: '16px' }}>
          Already have an account?{' '}
          <Link to="/" style={{ color: '#1A56DB', fontWeight: 600, textDecoration: 'none' }}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;